
import { insurancePage,insuranceForm } from '@/model/javaApi/detail.js'
import { PresentFormat } from '@/views/stencil/common/config'

// 获取保险信息并格式化 
const getFormatInfo =  async (data) => {
    // 获取商品详情
    let pageData = await insurancePage(data)
    // 获取填单字段
    let fromData = await insuranceForm(data)
    if(pageData && fromData){
        // return 格式化赠险数据结果
        return PresentFormat(pageData,fromData);
    }
  
}

// 获取默认方案
const getDeScheme = (schemes,scheme_code) =>{
  // 根据地址栏的方案code(scheme_code) / 后台返回(schemes)的默认方案 返回当前选中的方案 
  if(schemes.length){
      return (schemes.filter((item,index) => {
          return scheme_code ? item.schemeCode ==  scheme_code : item.isDefault
      })[0])
  }else{
      return {}
  }
}

export {
  getFormatInfo,
  getDeScheme
}